module.exports = __webpack_public_path__ + "assets/img/investmentAssistant-banner.cb3554be.png";